import Input from '../../components/Input';
import Select from '../../components/Select';
import translateLabel from '../../helpers/translateLabel';
import roles from '../../constants/roles';
import mandatoryFields from '../../configs/admins';
import DatePicker from '../../components/DatePicker';
import translations from '../../translations/de';

export default function getFormInput({ name, value, register, control, error, disabled, index }) {
    if (name === 'deleted_at') {
        return value ? (
            <DatePicker
                disabled={true}
                key={index}
                label={translateLabel(name)}
                selectText={translations.select_date}
                name={name}
                control={control}
                error={error}
                withTime
                isRequired={mandatoryFields.find((field) => (field === name ? true : false))}
            />
        ) : null;
    } else if (name === 'roles') {
        return (
            <Select
                key={index}
                label={translateLabel(name)}
                name="roles"
                options={roles}
                control={control}
                error={error}
                disabled={disabled}
                multiple={true}
                isRequired={true}
            />
        );
    } else if (name === 'password') {
        return !disabled ? (
            <Input
                key={index}
                ispassword={true}
                label={translateLabel(name)}
                name={name}
                {...register(name, {
                    required: mandatoryFields.find((field) => (field === name ? true : false)),
                })}
                error={error}
                disabled={disabled}
            />
        ) : null;
    } else {
        return (
            <Input
                key={index}
                ispassword={name === 'password'}
                label={translateLabel(name)}
                name={name}
                {...register(name, {
                    required: mandatoryFields.find((field) => (field === name ? true : false)),
                })}
                error={error}
                disabled={disabled}
            />
        );
    }
}
